import MultipleChoiceQuestionTemplate from '~/pages/anatomyV2/libs/components/MultipleChoiceQuestionTemplate'
import { MULTIPLE_CHOICE_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/multipleChoiceCorrectAnswers'
import {
  corePNG,
  coreWEBP,
  feetPNG,
  feetWEBP,
  innerEarPNG,
  innerEarWEBP,
  spinePNG,
  spineWEBP,
} from '~/pages/anatomyV2/postureInfluence/constants'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 3

const OPTIONS = [
  {
    key: 'core',
    i18nKey: 'onboarding.postureInfluence.options.core',
    png: corePNG,
    webp: coreWEBP,
  },
  {
    key: 'spine',
    i18nKey: 'onboarding.postureInfluence.options.spine',
    png: spinePNG,
    webp: spineWEBP,
  },
  {
    key: 'innerEar',
    i18nKey: 'onboarding.postureInfluence.options.innerEar',
    png: innerEarPNG,
    webp: innerEarWEBP,
  },
  {
    key: 'feet',
    i18nKey: 'onboarding.postureInfluence.options.feet',
    png: feetPNG,
    webp: feetWEBP,
  },
]

const PostureInfluenceAnatomyV2 = (props: TPageProps) => (
  <MultipleChoiceQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.postureInfluence.title"
    options={OPTIONS}
    correctOptionKey={
      MULTIPLE_CHOICE_CORRECT_ANSWERS[PageId.POSTURE_INFLUENCE_ANATOMY_V2_1]!
    }
    correctExplanationI18nKey="onboarding.postureInfluence.correctExplanation"
    incorrectTitleI18nKey="onboarding.postureInfluence.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.postureInfluence.incorrectExplanation"
    question="Body part that influences posture most"
  />
)

export default PostureInfluenceAnatomyV2
